import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    // Use useRef (not useState) to prevent double-execution under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace("#", "?"));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (res.ok) {
          const userData = await res.json();
          setUser(userData);
          navigate("/dashboard", { replace: true, state: { user: userData } });
        } else {
          navigate("/", { replace: true });
        }
      } catch {
        navigate("/", { replace: true });
      }
    };

    exchangeSession();
  }, [navigate, setUser]); // eslint-disable-line react-hooks/exhaustive-deps -- API is a module-level const; only run once on mount

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "#FAF9F6" }}>
      <div className="flex flex-col items-center gap-6">
        <div className="w-16 h-16 rounded-full border-4 border-[#FF8A65] border-t-transparent animate-spin" />
        <div className="text-center">
          <h2 className="text-xl font-bold text-slate-800 font-['Nunito']">Signing you in...</h2>
          <p className="text-slate-500 mt-1 font-['Figtree']">Setting up your pet world</p>
        </div>
      </div>
    </div>
  );
}
